import { DEFAULT_MAP_COORDINATES } from '../../../consts/g-map-options'

const WICKET_POLYGON_HEADER = 'POLYGON'

// if (navigator.geolocation) {
//   navigator.geolocation.getCurrentPosition(showPosition)
// } else {
//   x.innerHTML = 'Geolocation is not supported by this browser.'
// }

export const findShapeCenter = wicketArray => {
  if (!wicketArray.length) {
    return {
      lat: DEFAULT_MAP_COORDINATES.LAT,
      lng: DEFAULT_MAP_COORDINATES.LONG
    }
  }

  const firstShape = wicketArray[0]

  switch (firstShape.type) {
    case 'circle':
      return firstShape.center
    case 'rectangle':
      const bounds = firstShape.bounds
      return {
        lat: (Number(bounds.north) + Number(bounds.south)) / 2,
        lng: (Number(bounds.east) + Number(bounds.west)) / 2
      }
    default: //poly
      const coordinates = firstShape.coords
      let sumLat = 0
      let sumLng = 0
      coordinates.forEach(c => {
        sumLat += c.lat
        sumLng += c.lng
      })

      return {
        lat: sumLat / coordinates.length,
        lng: sumLng / coordinates.length
      }
  }
}

export const WicketToGoogle = wicketArray => {
  const returnValue = []

  wicketArray.forEach(wicket => {
    if (wicket.lat && wicket.long && wicket.radius) {
      returnValue.push({
        type: 'circle',
        id: wicket.id,
        name: wicket.name,
        isNew: wicket.isNew ? wicket.isNew : false,
        center: { lat: wicket.lat, lng: wicket.long },
        radius: wicket.radius
      })
    } else {

      const polyArray = wicket.wkt
        .replace(WICKET_POLYGON_HEADER, '')
        .replace('((', '')
        .replace('))', '')
        .split(',')

      // if (polyArray.length === 4) {
      //   // this is a rectange defined by two points or 4 lines
      //   returnValue.push({
      //     type: 'rectangle',
      //     id: wicket.id,
      //     name: wicket.name,
      //     isNew: wicket.isNew ? wicket.isNew : false,
      //     bounds: {
      //       north: polyArray[0],
      //       west: polyArray[1],
      //       south: polyArray[2],
      //       east: polyArray[3]
      //     }
      //   })
      // } else {
      //   const googlePolyArray = []
      //   for (let i = 0; i < polyArray.length; i = i + 2) {
      //     googlePolyArray.push({
      //       lat: Number(polyArray[i]),
      //       lng: Number(polyArray[i + 1])
      //     })
      //   }
      //   returnValue.push({
      //     type: 'polygon',
      //     id: wicket.id,
      //     name: wicket.name,
      //     isNew: wicket.isNew ? wicket.isNew : false,
      //     coords: googlePolyArray
      //   })
      // }

      const googlePolyArray = []
      polyArray.forEach( point => {
        const [lng, lat] = point.split(' ')
        googlePolyArray.push({
          lat: Number(lat),
          lng: Number(lng)
        })
      })
      returnValue.push({
        type: 'polygon',
        id: wicket.id,
        name: wicket.name,
        isNew: wicket.isNew ? wicket.isNew : false,
        coords: googlePolyArray
      })
    }
  })

  return returnValue
}

export const GoogleToWicket = shapeArray => {
  const returnValue = []
  //return returnValue
  shapeArray.forEach(oneShape => {
    switch (oneShape.type) {
      case 'circle':
        returnValue.push({
          id: oneShape.id,
          isNew: oneShape.isNew,
          lat: oneShape.center.lat,
          long: oneShape.center.lng,
          radius: oneShape.radius,
          name: oneShape.name
        })

        break
      case 'rectangle':
        const wktProtoRectangle = oneShape.bounds.north
          ? [
              oneShape.bounds.north,
              oneShape.bounds.west,
              oneShape.bounds.south,
              oneShape.bounds.east
            ]
          : [
              oneShape.bounds.Ua.hi,
              oneShape.bounds.Ha.lo,
              oneShape.bounds.Ua.lo,
              oneShape.bounds.Ha.hi
            ]
        returnValue.push({
          id: oneShape.id,
          isNew: oneShape.isNew,
          name: oneShape.name,
          wkt: `${WICKET_POLYGON_HEADER}(${wktProtoRectangle.join(',')})`
        })

        break
      default: // polygon
        const wktProto = []
        const firstPoint = {}
        oneShape.coords.forEach((c, index) => {
          // wktProto.push(c.lat)
          // wktProto.push(c.lng)
          if(index === 0) {
            firstPoint.lng = c.lng
            firstPoint.lat = c.lat
          }

          wktProto.push(`${c.lng} ${c.lat}`)

          if (
            index === oneShape.coords.length - 1 &&
            (c.lng !== firstPoint.lng || c.lat !== firstPoint.lat)
          ) {
            wktProto.push(`${firstPoint.lng} ${firstPoint.lat}`)
          }
        })
        returnValue.push({
          id: oneShape.id,
          isNew: oneShape.isNew,
          name: oneShape.name,
          wkt: `${WICKET_POLYGON_HEADER}((${wktProto.join(',')}))`
        })
    }
  })

  return returnValue
}
